module.exports = __webpack_public_path__ + "img/img_toupiao.9f8cbea6.png";